import { formatDatum } from './dates'

export type Kohorte = { beginn: string; anzahl: number }

export const ALLE_KOHORTEN = 'alle'

export function kohortenVon(rows: readonly { beginn: string | null }[]): Kohorte[] {
  const anzahl = new Map<string, number>()
  for (const { beginn } of rows) if (beginn !== null) anzahl.set(beginn, (anzahl.get(beginn) ?? 0) + 1)
  return [...anzahl]
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([beginn, n]) => ({ beginn, anzahl: n }))
}

export const kohorteLabel = (beginn: string): string => `Start ${formatDatum(beginn)}`
